<ng-container *ngIf="isAirSearchFormVisible">
     <btn type="actionHeaderLink"
          (click)="resetAirSearchForm()"
          [label]="wording.resetAirSearchForm"
          *permissionIf="'iqba.searchForm.reset'"></btn>
     <ng-container *ngIf="wayType!=eWayType.Oneway">
          <btn type="actionHeaderLink"
               [label]="wording.oneWay"
               (click)="changeWayType(eWayType.Oneway)"
               *permissionIf="'iqba.searchForm.sector'"></btn>
     </ng-container>
     <ng-container *ngIf="wayType!='Return'">
          <btn type="actionHeaderLink"
               [label]="wording.roundWay"
               (click)="changeWayType(eWayType.Return)"
               *permissionIf="'iqba.searchForm.sector'"></btn>
     </ng-container>
     <ng-container *ngIf="wayType !='Multiple'">
          <btn type="actionHeaderLink"
               [label]="wording.multipleWay"
               (click)="changeWayType(eWayType.Multiple)"
               *permissionIf="'iqba.searchForm.sector'"></btn>
     </ng-container>
</ng-container>
<btn *ngIf="airSearchContext===eAirSearchContext.watabi"
     type="actionUndo"
     (onClick)="redirectionToWatabi()"
     [label]="wording.redirectionToWatabi"></btn>
<btn *ngIf="hasAirSearchRequest && canUseAirSearchForm" type="actionUndo"
     (click)="closeAirSearchForm()"
     [label]="isAirSearchFormVisible ? wording.closeForm : wording.openForm"></btn>
